import React, { useEffect, useState } from 'react'
import cn from 'clsx'
import { Loader } from '@corecomponents/ui'
import { HEADER_TYPE } from '@utils/enum'
import s from '@components/Common/Layout/Layout.module.css'

const Loading = () => (
  <div className="w-80 h-80 flex items-center text-center justify-center p-3">
    <Loader />
  </div>
)

const dynamicProps = {
  loading: Loading,
  ssr: false,
}

const Sidebar = React.lazy(() => import('../Sidebar/Sidebar'))
const AmbassdorHeader = React.lazy(() => import('../AmbassdorHeader'))

export interface LayoutProps {
  isProtected?: boolean
  variant?: 'Normal' | 'NoPadding'
  noScroll? : boolean
  children?: React.ReactNode
  background?: any
  hideCohort?: boolean
  isBackButtonNeeded?: boolean
  isExitModalNeeded?: boolean
  isSidebarNeeded?: boolean
}

const LayoutWrapper: React.FC<LayoutProps> = ({
  children,
  isProtected,
  background,
  variant = 'Normal',
  hideCohort = false,
  isBackButtonNeeded = false,
  isExitModalNeeded = false,
  isSidebarNeeded = true
}) => {
  const [sidebarOpened, setSidebarOpened] = useState(false)
  const [mobile, setMobile] = useState(false)

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1024) {
        setMobile(true)
      } else {
        setMobile(false)
      }
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <div className={cn(s.root)}>
      {!mobile && isSidebarNeeded && (
        <Sidebar
          slideOver={mobile}
          isOpen={sidebarOpened}
          onClose={() => {
            setSidebarOpened(false)
          }}
        />
      )}
      <div className={`flex ${mobile || !isSidebarNeeded ? 'w-full' : 'w-[calc(100vw-280px)]' }  flex-col`}>
        <AmbassdorHeader
          headerType={HEADER_TYPE.AFTER_REGISTRATION}
          mobile={mobile}
          isPwlogoRequired={true}
          isBackButtonNeeded={isBackButtonNeeded}
          isExitModalNeeded={isExitModalNeeded}
          isSidebarNeeded={isSidebarNeeded}
        />

        {children}
      </div>
    </div>
  )
}

export default LayoutWrapper
